import React from 'react';
import sponsorshipBenefitsPdf from 'file-loader?name=docs/[name].[ext]!../../../assets/docs/SPONSORSHIP BENEFITS.pdf';

const ProjectPartners = () => (
	<div className="container main">
		<h2>Partenaires du projet</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<p>
					Nous remercions les partenaires figurant ci-dessous pour le soutien qu’ils apportent au portail depuis son inauguration en 2012.
					Cliquez <a href="https://www.oecd-ilibrary.org/fr/science-and-technology/oecd-globalrecalls-portal_d8b0d605-en">ici</a> pour accéder au rapport décrivant les améliorations dont a bénéficié le portail entre 2015 et 2019.
				</p>
			</div>
			<div className="col-sm-6">
				<p>
					Si votre organisation souhaite soutenir le portail, veuillez prendre contact avec le Secrétariat de l’OCDE à l’adresse <a href="mailto:GlobalRecallsdata@oecd.org">GlobalRecallsdata@oecd.org</a>.
				</p>
			</div>
		</div>
		<hr/>
		<div className="row partners">
			<div className="col-sm-6">
				<h2>Australie</h2>
				<h4>Commission australienne de la concurrence et de la consommation (<i>ACCC, Australian Competition & Consumer Commission</i>)</h4>
				<p>
					L’ACCC est une autorité statutaire indépendante qui promeut la concurrence, le commerce équitable et la sécurité des produits dans l’intérêt des consommateurs, des entreprises et de la communauté australienne.
					Elle a pour principales responsabilités de veiller au respect des dispositions de la loi de 2010 sur la concurrence et la consommation relatives à la concurrence, à la protection des consommateurs, au commerce équitable et à la sécurité des produits, ainsi que de réguler les infrastructures nationales et de réaliser des études de marché.
				</p>
				<p>
					En tant qu’organisme national de réglementation de la sécurité des produits, l’ACCC administre un ensemble de normes obligatoires et d’interdictions de produits.
					En outre, elle a pour rôle d’identifier et de résoudre les principaux risques liés à la sécurité des produits auxquels font face les consommateurs australiens.
					Elle s’appuie sur un ensemble de stratégies pour gérer les risques les plus importants, en s'appuyant sur la formation et au besoin, sur la réglementation.
				</p>
				<img src={require('../../../assets/images/logos/australian.png')} alt=""/>
				<p>
					<a href="http://www.accc.gov.au/content/index.phtml/itemId/54217#top" target="_blank" className="btn btn-info btn-sm">SIGNALER UN PROBLÈME DE SÉCURITÉ</a>
				</p>
				<hr/>

				<h2>Brésil</h2>
				<h4>Brazilian National Institute of Metrology, Quality and Technology (Inmetro)</h4>
				<p>
					Inmetro, organisation fédérale responsable de la mise en œuvre des politiques nationales sur la métrologie et la qualité, constitue l’organisme d’accréditation brésilien et le point de contact central pour les obstacles techniques au commerce au Brésil.
				</p>
				<p>
					En tant qu’organisme de réglementation de plus de 140 catégories de produits non alimentaires (voir la liste à l’adresse suivante :
					<a href="http://inmetro.gov.br/qualidade/rtepac/compulsorios.asp" target="_blank">http://inmetro.gov.br/qualidade/rtepac/compulsorios.asp</a>, Inmetro élabore des programmes d’évaluation
					de la conformité dont l’objectif principal est d’améliorer la sécurité des produits. Les produits soumis à des programmes obligatoires d’évaluation de la conformité font l'objet d'un suivi dans les 26 États brésiliens, le but étant de protéger les consommateurs et de retirer du marché les produits irréguliers. Les activités de surveillance des marchés d’Inmetro permettent d’identifier les changements importants en matière de normes nationales et de modifications de conception des produits visant à améliorer leur sécurité. Elles fournissent également une base technique aux mesures d’application des lois, lorsque cela s’avère nécessaire.
				</p>
				<img src={require('../../../assets/images/logos/inmetro.png')} alt=""/>
				<p>
					<a href="https://www.gov.br/inmetro/pt-br/canais_atendimento/ouvidoria/faca-sua-manifestacao" target="_blank" className="btn btn-info btn-sm">SIGNALER UN PROBLÈME DE SÉCURITÉ</a>
				</p>
				<hr/>

				<h2>Canada</h2>
				<h4>Santé Canada</h4>
				<p>
					Santé Canada est le ministère fédéral responsable d’aider les Canadiens à maintenir et à améliorer leur santé.
					Santé Canada s’est engagé à améliorer la vie de tous les Canadiens et à faire en sorte que la santé de la population du pays soit parmi les meilleures au monde, comme en témoignent la longévité, le mode de vie et l’utilisation efficace du système public de soins de santé.
				</p>
				<p>
					Dans le cadre de son rôle d’organisme de réglementation, Santé Canada aide à protéger le public canadien en effectuant des recherches sur les risques pour la santé et la sécurité associés aux nombreux produits de consommation et cosmétiques utilisés quotidiennement par les Canadiens, en évaluant ces risques et en collaborant à leur gestion.
				</p>
				<img src={require('../../../assets/images/logos/canada.png')} alt=""/>
				<p>
					<a href="http://www.healthycanadians.gc.ca/report-signalez/index-eng.php" target="_blank" className="btn btn-info btn-sm">SIGNALER UN PROBLÈME DE SÉCURITÉ</a>
				</p>
				<hr/>

				<h2>Mexique</h2>
				<h4>Agence fédérale mexicaine de Protection des Consommateurs (Profeco)</h4>
				<p>
					L'Agence fédérale de Protection des Consommateurs (Profeco) du Mexique est une agence gouvernementale, créée en 1976, qui a l'autorité administrative
					et la charge de promouvoir et de protéger les droits et les intérêts des consommateurs,
					en recherchant l'équité et la sécurité juridique dans les relations entre les fournisseurs et les consommateurs.
				</p>
				<p>
					Le cadre juridique de Profeco prévoit -comme l'un des principes de base dans les relations de consommation- la protection de la vie, de la santé et de la sécurité des consommateurs
					contre les risques causés par les produits, les pratiques de fourniture de produits et les services considérés comme dangereux ou nuisibles. Pour cela, parmi ses missions, Profeco
					applique et surveille l'application des normes techniques pour assurer la sécurité et la qualité des produits, et évalue également les produits pour garantir qu'ils soient conformes aux normes techniques et ne représentent pas un risque pour la santé ou la sécurité des consommateurs.
				</p>
				<img src={require('../../../assets/images/logos/profeco.png')} alt=""/>
				<p>
					<a href="https://www.gob.mx/profeco/articulos/proceso-y-requisitos-de-quejas-y-denuncias" target="_blank" className="btn btn-info btn-sm">SIGNALER UN PROBLÈME DE SÉCURITÉ</a>
				</p>
			</div>
			
			<div className="col-sm-6">
				<h2>Commission européenne</h2>
				<h4>Direction générale de la justice et des consommateurs (DG JUST) de la Commission européenne</h4>
				<p>
					La Commission européenne contribue à élaborer la stratégie générale de l’UE, formule des propositions de législations et de politiques communautaires, suit leur mise en œuvre, et gère le budget de l’UE.
				</p>
				<p>
					La Direction générale de la justice et des consommateurs (DG JUST) de la Commission européenne contribue à garantir que les biens de consommation vendus dans l’Union européenne (UE) sont sûrs, que le marché intérieur de l’UE fonctionne dans l’intérêt des consommateurs et que l’UE contribue à protéger et à améliorer la santé et la sécurité de ses citoyens.
				</p>
				<p>
					La DG JUST gère Safety Gate, le système d’alerte rapide pour les produits non alimentaires dangereux.
					Ce système permet aux autorités nationales des pays de l’UE et de l’EEE de communiquer rapidement à tous les pays participant au système l’ensemble des informations
					concernant les mesures prises à l’encontre des produits dangereux détectés sur leur marché. En conséquence, il est possible de prendre des mesures appropriées qui s'appliquent dans tout le marché unique européen.
				</p>
				<p>
					Safety Gate couvre les produits non alimentaires dangereux destinés aux consommateurs (par exemple, un jouet, un cosmétique, des vêtements) et aux professionnels
					(par exemple, une perceuse électrique, une machine, un produit de construction). Trente pays participent actuellement au système, les pays membres de l’UE et les trois pays de l’EEE/AELE (Islande, Liechtenstein et Norvège).
				</p>
				<p><strong>Avis juridique</strong></p>
				<p>
					Les données fournies par la Commission européenne sont publiées à titre gracieux sur le site web du portail <a href="https://ec.europa.eu/safety-gate-alerts/screen/webReport" target="_blank">Safety Gate</a>.
				</p>
				<p>
					Les informations publiées sur le portail Safety Gate sont fournies par les <a href="https://ec.europa.eu/safety/consumers/consumers_safety_gate/menu/documents/Safety_Gate_contacts.pdf" target="_blank">points de contact officiels</a> des autorités
					des pays membres chargées de la surveillance des marchés. Aux termes de l’annexe II.10 de la directive relative à la sécurité générale des produits (2001/95/CE),
					la responsabilité des informations fournies incombe à la partie notifiante. La Commission n’assume aucune responsabilité quant à l’exactitude des informations fournies.
				</p>
				<p><strong>Réutilisation des alertes</strong></p>
				<p>
					La politique de la Commission en matière de réutilisation d’informations est définie dans la décision 2011/833/UE de la Commission du 12 décembre 2011 relative à la réutilisation des documents de la Commission.
					La réutilisation des informations publiées sur le Safety Gate est autorisée à condition que le sens ou le message originel des alertes ne soit pas altéré et que la source soit citée. 
				</p>
				<p>
					Information on reuse of alerts is available here: <a href="https://ec.europa.eu/safety/consumers/consumers_safety_gate/menu/documents/New_disclaimer_EN.pdf" target="_blank">https://ec.europa.eu/safety/consumers/consumers_safety_gate/menu/documents/New_disclaimer_EN.pdf</a>
				</p>
				<img src={require('../../../assets/images/logos/european.png')} alt=""/>
				<p>
					<a href="mailto:Sanco-Reis@ec.europa.eu" target="_blank" className="btn btn-info btn-sm">SIGNALER UN PROBLÈME DE SÉCURITÉ</a>
				</p>
				<hr/>

				<h2>États-Unis</h2>
				<h4>Commission de la sécurité des produits de consommation des États-Unis (CPSC, <i>U.S. Consumer Product Safety Commission</i>)</h4>
				<p>
					La Commission de la sécurité des produits de consommation des États-Unis est chargée de protéger le public contre les risques déraisonnables de blessures ou de décès causés par des milliers
					de types de produits de consommation relevant de la compétence de cet organisme. La CPSC s’engage à protéger les consommateurs et les familles contre les produits qui présentent un risque
					électrique, chimique, mécanique ou un risque d'incendie, ou qui peuvent blesser les enfants. Les efforts déployés par la CPSC, depuis son établissement en 1973, pour assurer la sécurité des produits de consommation - tels que jouets, lits d’enfant, outils électriques, briquets ou les produits chimiques ménagers - ont contribué de façon significative à la baisse du taux de décès et de blessures associés aux produits de consommation.
				</p>
				<img src={require('../../../assets/images/logos/us.png')} alt=""/>
				<p>
					<a href="http://www.saferproducts.gov/" target="_blank" className="btn btn-info btn-sm">SIGNALER UN PROBLÈME DE SÉCURITÉ</a>
				</p>
				<hr/>

				<h2>GS1</h2>
				<p>
					GS1 est une organisation internationale neutre, à but non lucratif, qui développe des normes et des solutions globales pour améliorer l'efficacité et la visibilité des chaînes d'approvisionnement à travers les industries.
					Elle fait appel à une communauté mondiale de partenaires commerciaux, d'organisations industrielles et de fournisseurs de technologie pour comprendre leurs besoins commerciaux et élaborer des normes mondiales en réponse à ces besoins.
					GS1 est piloté par près de deux millions d'organisations d'utilisateurs, dans plus de 20 industries, y compris le commerce de détail et les biens de consommation, les soins de santé, le transport et la logistique, et plus encore.
					Aujourd'hui, le système de normes GS1 est le système de normes de la chaîne d'approvisionnement le plus utilisé dans le monde.
					GS1 a des organisations membres locales dans plus de 110 pays et son siège social est à Bruxelles.
					Pour plus d'informations, visitez <a href="http://www.gs1.org" target="_blank">www.gs1.org</a>.
				</p>
				<img src={require('../../../assets/images/logos/gs1.png')} alt=""/>
			</div>
		</div>
	</div>
);

export default ProjectPartners;



// WEBPACK FOOTER //
// ./src/views/static/fr/project-partners.js